// @flow
import React from 'react';
import './LoadingBar.css';

type Props = {
  isVisible: boolean,
};

const LoadingBar = ({ isVisible }: Props) => {
  if (!isVisible) return null;

  return (
    <div className="loading-bar-container">
      <div className="loading-bar-wrapper">
        <div className="loading-bar" />
      </div>
    </div>
  );
};

export default LoadingBar;
